import React,{ useState,useEffect,useRef} from "react";
import moment from "moment";
import axios from '../../../plugins/axios.js';
import Paging from "./Common/Paging.jsx"
import { useTranslation } from 'react-i18next';
import Toast from "../../../plugins/useToast";
import Modal from "../../../components/Modal.jsx";
import BarcodePrint from "../component/Device/BarcodePrint.jsx";

import {ReactComponent as IconSearch } from "../../../assets/icons/ic-search.svg";
import {ReactComponent as IconArrowUp} from '../../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../../assets/icons/ic-check_blue.svg';
import {ReactComponent as IconEdit} from '../../../assets/icons/ic-admin-edit.svg';

const PmdMngt = ({handleSetConfirm}) => {
    const { t } = useTranslation();
    const isFirstRender = useRef(true);
    const [searchValue, setSearchValue] = useState("");
    const [dropdownInfo, setDropdownInfo] = useState({
        open: false,
        type: '', // 'ward' or 'bed'
        rowIndex: null,
        anchorRect: null,
        deviceId: null,
    });
    const [itemCount, setItemCount] = useState(50); 
    const countOptions = [50, 100, t('admin.all')];    
    const [searchSort, setSearchSort] = useState({
        column: '',
        param : '',
        order: 'ASC'
    });
    const [pagingInfo, setPagingInfo] = useState({
        currentPage: 1,
        totalPages: 50,        
        pageSize: 5,
        totalCount : 0
    });        
    const [deviceData, setDeviceData] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false); //전체 아이템 선택 관리 상태.    
    const [pmdList, setPmdList] = useState([
        {id : 1, name : 'Device Model 1'},
        {id : 2, name : 'Device Model 2'},
        {id : 3, name : 'Device Model 3'}
    ]);
    const [wardList, setWardList] = useState([]);
    const [bedList, setBedList] = useState([]);
    const [tempDeviceData, setTempDeviceData] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isPrint, setIsPrint] = useState(false);
    const deviceModelInfoRef = useRef([]);

    const closeDropdown = () => setDropdownInfo({ open: false, type: '', rowIndex: null, anchorRect: null, deviceId: null });

    // ✅ 정렬 시 Icon 변경
    const getSortIcon = (column) => {
        if (searchSort.column == column) {
            return searchSort.order == 'ASC' ? 
                <IconArrowUp className="inline-block" /> : 
                <IconArrowDown className="inline-block" />;
        }
        return <IconArrowDown className="inline-block" />; // 기본 아이콘
    };

    // ✅ Sort UseState 변경
    const handleSort = (column,param) => {
        setSearchSort((prev) => ({
            column: column,
            param : param,
            order: prev.column == column && prev.order == 'ASC' ? 'DESC' : 'ASC'
        }));
    };    

    // ✅ 페이지 이동 함수
    const goToPage = (page) => {
        if (page < 1 || page > pagingInfo.totalPages) return;
        setPagingInfo((prev) => ({ ...prev, currentPage: page }));
        getDeviceList(page-1);
    };

    // ✅ Enter키 입력 시 검색 
    const handleEnter = (e) => {
        if (e.keyCode === 13) {
            getDeviceList(0);
        }
    }

    // ✅ Device List 가져오기
    const getDeviceList = async (page) => {
        try {
            const keyword = searchValue;            
            const size = itemCount == t('admin.all') ? 0 : itemCount;
            const sortBy = searchSort.param;
            const sort = searchSort.order;
            const url = `/devices?page=${page}&${keyword ? 'keyword=' + keyword + '&' : ''}${size ? 'size=' + size + '&' : ''}${sortBy ? 'sortBy=' + sortBy + '&' : ''}${sort ? 'sort=' + sort : ''}`;

            const resDevice = await axios.get(url);
            if(resDevice.code != 200) throw resDevice;

            //데이터 시 isCheck를 넣어주고, CheckBox로 쓰기 위함.
            const deviceListWithCheck = resDevice.data.content.map(device => ({
                ...device,
                isCheck: false,
                isEdit : false
            }));           

            setDeviceData(deviceListWithCheck);
            setIsAllSelected(false); // 전체 선택 해제

            setPagingInfo({
                currentPage: (resDevice.data.page+1),
                totalPages: resDevice.data.totalPages,
                pageSize: resDevice.data.size,
                totalCount : resDevice.data.totalElements
            });
        } catch (err) {
            console.warn(err);
        }
    }

    // ✅ Equpment Model, Ward, Bed List 가져오기
    const getEditOptions = async () => {
        try{
            // PMD List
            const resPmd = await axios.get('/device-models');
            const pmdList = resPmd.data.deviceModels.map((pmd) => ({
                id: pmd.id,
                name: pmd.model
            }));
            setPmdList(pmdList);
            
            // Ward List
            const resWard = await axios.get('/wards');
            const wardList = resWard.data.content.map((ward) => ({
                id: ward.id,
                name: ward.name
            }));
            setWardList(wardList);

            // Bed 1~32
            setBedList(Array.from({ length: 32 }, (_, i) => i + 1));
        }
        catch(err){
            console.warn(err);
        }
    }

    // ✅ Edit Device 함수
    const handleEditDevice = async (device) => {
        try{
            const payload = {
                "deviceModelId" : device.deviceModelId,
                "serial" : device.serial,
                "wardId" : device.wardId,
                "bedNumber" : device.bedNumber
            }

            const res = await axios.put(`/device/${device.id}`, payload);
            if(res.code != 200) throw res;

            Toast({ isSuccess: true, msg: t('admin.device.editSuccess') });

            const updatedData = deviceData.map((item) =>
                item.id === device.id ? { ...item, isEdit: false } : item
            );
            
            setDeviceData(updatedData);
            setTempDeviceData([]);
        }
        catch (err) {
            Toast({ isSuccess: false, msg: t('admin.device.editFail') });
            console.warn(err);
        }
    }

    // ✅ delect Device 함수
    const handleDeleteDevices = async () => {
        try{
            const selectedDevices = deviceData.filter(device => device.isCheck);
            if (selectedDevices.length === 0) {
                Toast({ isSuccess: false, msg: t('admin.device.noSelectedForDelete') });
                return;
            }

            const deviceIds = selectedDevices.map(device => device.id);            
            const res = await axios.delete('/devices', {params : {deviceIds : deviceIds.join(',')}});                        
            if(res.code != 200) throw res;

            Toast({ isSuccess: true, msg: t('admin.device.deleteSuccess') });
            getDeviceList(0);
            
        }
        catch (err) {
            Toast({ isSuccess: false, msg: t('admin.device.deleteFail') });
            console.warn(err);
        }
    }

    //체크된 값 중 Status 상태 값 체크 함수
    const isCheckedStatus = () => {
        const checkDevices = deviceData.filter(device => device.isCheck);
        console.log('checkDevices', checkDevices);
        const hasActive = checkDevices.some(device => device.status === 'ACTIVE');
        if(hasActive){
            setIsAlertOpen(true);            
        }else{
            handleSetConfirm('pmd','delete', true,handleDeleteDevices,null,'','',t('admin.device.confirm.deleteConfirm'))
        }
    }

    const getDeviceModelInfo = async () => {
        try {
                const deviceModelRes = await axios.get('/device-models')
                console.log('deviceModelRes', deviceModelRes);
                if (deviceModelRes.code != '200') throw deviceModelRes
                deviceModelInfoRef.current = deviceModelRes.data.deviceModels
            }
            catch (err) { 
            console.warn(err)
        }
    }

    // ✅ 검색, itemCount, Paging, 정렬 시 List 변경.
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        getDeviceList(0);
    }, [itemCount,searchSort]);

    useEffect(() => {
        if (isAllSelected) {
            // 전체 선택: 모든 아이템의 isCheck를 true로 변경
            const updatedData = deviceData.map(dept => ({
                ...dept,
                isCheck: true
            }));
            setDeviceData(updatedData);
        } else {
            // 전체 해제: 모든 아이템의 isCheck를 false로 변경
            const updatedData = deviceData.map(dept => ({
                ...dept,
                isCheck: false
            }));
            setDeviceData(updatedData);
        }
    }, [isAllSelected]);

    useEffect(() => {
        getDeviceList(0);
        getEditOptions(); //한번만 하면 됨.        
        getDeviceModelInfo();
    }, []);

    useEffect(() => {
        // 드롭다운 외부 클릭 시 닫기
        const handleClickOutside = (event) => {
            if (!event.target.closest('.select-dropdown')) {
                setDropdownInfo({
                    open: false,
                    type: '',
                    rowIndex: null,
                    anchorRect: null,
                    deviceId: null,
                });
            }
        };

        // 테이블 스크롤 시 드롭다운 닫기
        const tableScrollEl = document.querySelector('.scrollbar-10px');
        const handleTableScroll = () => {
            if (
                dropdownInfo.open &&
                (dropdownInfo.type === 'ward' || dropdownInfo.type === 'bed')
            ) {
                setDropdownInfo({
                    open: false,
                    type: '',
                    rowIndex: null,
                    anchorRect: null,
                    deviceId: null,
                });
            }
        };
        document.addEventListener('click', handleClickOutside);
        if (tableScrollEl) {
            tableScrollEl.addEventListener('scroll', handleTableScroll);
        }
        return () => {
            document.removeEventListener('click', handleClickOutside);
            if (tableScrollEl) {
                tableScrollEl.removeEventListener('scroll', handleTableScroll);
            }
        };
    }, [dropdownInfo]);

    const isAnyChecked = deviceData.some(device => device.isCheck);

    return (        
        <div>
            <h1 className="admin-title mb-[24px]">{t('admin.device.title')}<span className="text-[#E1E4E5] font-pretendard text-[16px] font-normal leading-[160%] pl-[8px]">{`(${itemCount == t('admin.all') ? pagingInfo.totalCount : (pagingInfo.totalCount < (itemCount * pagingInfo.currentPage) ? pagingInfo.totalCount : (itemCount * pagingInfo.currentPage))}/${pagingInfo.totalCount})`}</span></h1>
            <div className="flex justify-between mb-[17px]">
                <div className="flex gap-[8px]">   
                    <div className={`${!isAnyChecked ? 'disabled !cursor-default' : ''} admin-normal-btn w-[88px] h-[32px]`} onClick={isAnyChecked ? () => isCheckedStatus() : null  }>
                        <span className="btn-content">{t('admin.delete')}</span>
                    </div>
                </div> 
                <div className="flex items-center gap-[12px]"> 
                    <div className="relative">                        
                        <input
                            type="text"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyDown={handleEnter}
                            placeholder={t('admin.searchPlaceholder')}
                            className="admin-input w-[280px] pr-[30px]"
                            maxLength={50}
                        />
                        <span className="ml-2 absolute bottom-[6px] right-2" onClick={() => getDeviceList(0)}>
                            <IconSearch className="cursor-pointer"/>
                        </span>
                    </div>                    
                    <div className="w-[1px] h-[24px] bg-[#0D0D0F]"></div>                                        
                    <div className="relative select-dropdown">
                        <div
                            className="flex items-center justify-between w-[120px] h-[32px] px-[8px] rounded-[6px] border border-[#0D0D0F] text-[#DEDEDE] cursor-pointer bg-gradient-to-b from-[#5B5C60] to-[#303237] shadow-[inset_0_-2px_1px_0_rgba(255,255,255,0.10),inset_0_2px_0_0_rgba(255,255,255,0.12)]"
                            onClick={e => {
                                e.stopPropagation();
                                const rect = e.currentTarget.getBoundingClientRect();
                                setDropdownInfo({
                                    open: !(dropdownInfo.open && dropdownInfo.type === 'itemCount'),
                                    type: 'itemCount',
                                    anchorRect: rect,
                                });
                            }}
                        >
                            <div className="w-[200px]">{itemCount} {t('admin.items')}</div>
                            <div className="pointer-events-none">
                                {dropdownInfo.open && dropdownInfo.type === 'itemCount' ? <IconArrowUp /> : <IconArrowDown />}
                            </div>
                        </div>
                    </div>    
                    <div className="w-[1px] h-[24px] bg-[#0D0D0F]"></div>     
                    <div className={`${!isAnyChecked ? 'opacity-50' : ''} admin-normal-btn add w-[120px] h-[32px] whitespace-nowrap`} onClick={isAnyChecked ? () => setIsPrint(true) : null}>
                        <span className="btn-content">{t('admin.device.barcodePrint')}</span>
                    </div>                
                </div>
            </div>
            <div className="mb-[26px]">
                <div className="scrollbar scrollbar-10px" style={{ maxHeight: '680px', borderBottom: '2px solid #0D0D0F'}}>
                    <table className="admin-table w-full">
                        <thead>
                            <tr className="h-[42px]">
                                <th className="w-[80px]">
                                    <div className="w-full flex justify-center items-center">
                                        <div className="rounded-[6px] p-[6px] w-[36px]">
                                            <label className="flex gap-[4px]">
                                                <input
                                                    type="checkbox"
                                                    value={isAllSelected}
                                                    checked={isAllSelected}
                                                    onChange={() => setIsAllSelected(!isAllSelected)}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </th>                            
                                <th className="w-[160px]" onClick={() => handleSort('Equipment Model','DEVICE_MODEL')}>{t('admin.device.equipmentModel')} {getSortIcon('Equipment Model')}</th>
                                <th className="w-[160px]" onClick={() => handleSort('Serial Number','SERIAL_NUMBER')}>{t('admin.device.serialNumber')}{getSortIcon('Serial Number')}</th>
                                <th className="w-[228px]" onClick={() => handleSort('Ward','WARD')}>{t('admin.device.ward')}{getSortIcon('Ward')}</th>
                                <th className="w-[100px]" onClick={() => handleSort('Bed No.','BED_NUMBER')}>{t('admin.device.bedNo')}{getSortIcon('Bed No.')}</th>
                                <th className="w-[100px]" onClick={() => handleSort('Status','STATUS')}>{t('admin.device.status')}{getSortIcon('Status')}</th>
                                <th className="w-[180px]" onClick={() => handleSort('Start Date','CREATED_AT')}>{t('admin.device.startDate')}{getSortIcon('Start Date')}</th>
                                <th className="w-[180px]" onClick={() => handleSort('End Date','DISCONNECTED_AT')}>{t('admin.device.endDate')}{getSortIcon('End Date')}</th>
                                <th className="w-[180px]" onClick={() => handleSort('Last Modified Date','UPDATED_AT')}>{t('admin.device.lastModifiedDate')}{getSortIcon('Last Modified Date')}</th>
                                <th className="w-[140px] !cursor-default">{t('admin.edit')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                deviceData && deviceData.map((device, index) => {
                                    const isEditBedNumber = device.deviceModel == 'V20' // Rodney - V20 모델인 경우에만 Bed Number 수정 가능하게 변경

                                    return (
                                        <tr className={`${device.isCheck ? 'selected-row' : `${index % 2 == 0 ? 'bg-[#202024]' : 'bg-[#29292E]'}`} h-[42px]`} key={`${device.id}-${index}`}>
                                            <td onClick={(e) => e.stopPropagation()}>
                                                <div className="w-full flex justify-center items-center">
                                                    <div className="rounded-[6px] p-[6px] w-[36px]">
                                                        <label className="flex gap-[4px]">
                                                            <input
                                                                type="checkbox"
                                                                value={device.isCheck}
                                                                checked={device.isCheck}
                                                                onChange={() => {
                                                                    const updatedData = deviceData.map((item) =>
                                                                        item.id == device.id ? { ...item, isCheck: !item.isCheck } : item
                                                                    );
                                                                    setDeviceData(updatedData);
                                                                }}
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </td>                                            
                                            <td className="px-[4px]">
                                                {device.deviceModel || '-'}
                                            </td>                                            
                                            <td>
                                                {device.serial || '-'}
                                            </td>
                                            <td className="px-[4px]">
                                                {device.isEdit ? (                                                    
                                                    <div
                                                        className="relative select-dropdown"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const rect = e.currentTarget.getBoundingClientRect();
                                                            if (dropdownInfo.open && dropdownInfo.type === 'ward' && dropdownInfo.deviceId === device.id) {
                                                                // 이미 열려있는 경우 닫기
                                                                closeDropdown();
                                                            }else{
                                                                setDropdownInfo({
                                                                    open: true,
                                                                    type: 'ward',
                                                                    rowIndex: index,
                                                                    anchorRect: rect,
                                                                    deviceId: device.id,
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        <div className="flex items-center justify-between w-full h-[32px] px-[8px] rounded-[6px] border border-[#0D0D0F] text-[#DEDEDE] cursor-pointer bg-gradient-to-b from-[#5B5C60] to-[#303237] shadow-[inset_0_-2px_1px_0_rgba(255,255,255,0.10),inset_0_2px_0_0_rgba(255,255,255,0.12)]">
                                                            <div className="w-full">{device.wardName || '-'}</div>
                                                            <div className="pointer-events-none">
                                                                {dropdownInfo.open && dropdownInfo.type === 'ward' && dropdownInfo.deviceId === device.id ? <IconArrowUp /> : <IconArrowDown />}
                                                            </div>
                                                        </div>
                                                    </div> 
                                                ) : (
                                                    device.wardName || '-'
                                                )}
                                            </td>
                                            <td className="px-[4px]">
                                                {device.status == 'ACTIVE' && device.isEdit && isEditBedNumber ? (                                                    
                                                    <div
                                                        className="relative select-dropdown"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const rect = e.currentTarget.getBoundingClientRect();
                                                            if (dropdownInfo.open && dropdownInfo.type === 'bed' && dropdownInfo.deviceId === device.id) {
                                                                closeDropdown();
                                                            }else{
                                                                setDropdownInfo({
                                                                    open: true,
                                                                    type: 'bed',
                                                                    rowIndex: index,
                                                                    anchorRect: rect,
                                                                    deviceId: device.id,
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        <div className="flex items-center justify-between w-[90px] h-[32px] px-[8px] rounded-[6px] border border-[#0D0D0F] text-[#DEDEDE] cursor-pointer bg-gradient-to-b from-[#5B5C60] to-[#303237] shadow-[inset_0_-2px_1px_0_rgba(255,255,255,0.10),inset_0_2px_0_0_rgba(255,255,255,0.12)]">
                                                            <div className="w-[200px]">{device.bedNumber || '-'}</div>
                                                            <div className="pointer-events-none">
                                                                {dropdownInfo.open && dropdownInfo.type === 'bed' && dropdownInfo.deviceId === device.id ? <IconArrowUp /> : <IconArrowDown />}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    device.bedNumber || '-'
                                                )}
                                            </td>
                                            <td>{device.status ? device.status === 'ACTIVE' ? t('admin.device.active') : t('admin.device.disconnected') : '-'}</td>
                                            <td>{device.createdAt && moment(device.createdAt).isValid() ? moment(device.createdAt).format("YYYY-MM-DD HH:mm:ss") : '-'}</td>
                                            <td>{device.disconnectedAt && moment(device.disconnectedAt).isValid() ? moment(device.disconnectedAt).format("YYYY-MM-DD HH:mm:ss") : '-'}</td>
                                            <td>{device.updatedAt && moment(device.updatedAt).isValid() ? moment(device.updatedAt).format("YYYY-MM-DD HH:mm:ss") : '-'}</td>                                        
                                            <td className="px-[4px]">
                                                {
                                                    device.isEdit ? (
                                                        <div className="w-full flex justify-center gap-[4px]">
                                                            <div className="admin-normal-btn add w-[64px] h-[28px] p-[7px_8px]" onClick={() => handleEditDevice(device)}>
                                                                <span className="btn-content !text-[14px]">{t('admin.save')}</span>
                                                            </div>
                                                            <div className="admin-normal-btn w-[64px] h-[28px] p-[7px_8px]" onClick={() => {
                                                                //setDeviceData(deviceData.map(item => item.id == device.id ? { ...item, isEdit: !item.isEdit } : item))
                                                                setDeviceData(deviceData.map(item => item.id == device.id ? { ...tempDeviceData.find(tempItem => tempItem.id == device.id), isEdit: false, } : item));
                                                            }}>
                                                                <span className="btn-content !text-[14px]">{t('admin.cancel')}</span>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                         <IconEdit className={`w-[32px] h-[32px] p-[5px] inline-block cursor-pointer`} onClick={() => {
                                                            const updatedData = deviceData.map((item) =>
                                                                item.id == device.id ? { ...item, isEdit: !item.isEdit } : item
                                                            );         
                                                            setTempDeviceData(deviceData); // 현재 데이터를 임시 저장                                          
                                                            setDeviceData(updatedData);
                                                        }}/>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            {/* itemCount 드롭다운 */}
            {dropdownInfo.open && dropdownInfo.type === 'itemCount' && dropdownInfo.anchorRect && (
                <div
                    style={{
                        position: 'fixed',
                        top: dropdownInfo.anchorRect.bottom + window.scrollY + 2,
                        left: dropdownInfo.anchorRect.left + window.scrollX,
                        width: dropdownInfo.anchorRect.width,
                        zIndex: 9999,
                    }}
                    className="bg-[#1F1F1F] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)]"
                >
                    {countOptions.map((option, index) => (
                        <div
                            key={index}
                            className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                ${itemCount == option ? "text-[#3182F7]" : "text-white"}`}
                            onClick={e => {
                                e.stopPropagation();
                                setItemCount(option);
                                setDropdownInfo({ open: false, type: '', anchorRect: null });
                            }}
                        >
                            {option}
                            {itemCount == option && (
                                <IconCheck className="w-4 h-4 ml-2" />
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* ward 드롭다운 */}
            {dropdownInfo.open && dropdownInfo.type === 'ward' && dropdownInfo.anchorRect && (
                <div
                    style={{
                        position: 'fixed',
                        top: dropdownInfo.anchorRect.bottom + window.scrollY + 2,
                        left: dropdownInfo.anchorRect.left + window.scrollX,
                        width: dropdownInfo.anchorRect.width,
                        zIndex: 9999,
                    }}
                    className="bg-[#1F1F1F] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] max-h-[100px] scrollbar scrollbar-10px"
                >
                    {wardList.map((ward, idx) => (
                        <div
                            key={ward.id}
                            className={`cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                ${deviceData.find(d => d.id === dropdownInfo.deviceId)?.wardId === ward.id ? "text-[#3182F7]" : "text-white"}`}
                            onClick={() => {
                                setDeviceData(deviceData.map(item =>
                                    item.id === dropdownInfo.deviceId ? { ...item, wardId: ward.id, wardName: ward.name } : item
                                ));
                                setDropdownInfo({ open: false, type: '', anchorRect: null });
                            }}
                        >
                            {ward.name}
                            {deviceData.find(d => d.id === dropdownInfo.deviceId)?.wardId === ward.id && (
                                <IconCheck className="w-4 h-4 ml-2" />
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* bed 드롭다운 */}
            {dropdownInfo.open && dropdownInfo.type === 'bed' && dropdownInfo.anchorRect && (
                <div
                    style={{
                        position: 'fixed',
                        top: dropdownInfo.anchorRect.bottom + window.scrollY + 2,
                        left: dropdownInfo.anchorRect.left + window.scrollX,
                        width: dropdownInfo.anchorRect.width,
                        zIndex: 9999,
                        maxHeight: 300,
                        overflowY: 'auto',
                    }}
                    className="bg-[#1F1F1F] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] max-h-[100px] scrollbar scrollbar-10px"
                >
                    {bedList.map((bed, idx) => (
                        <div
                            key={bed}
                            className={`cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                ${deviceData.find(d => d.id === dropdownInfo.deviceId)?.bedNumber === bed ? "text-[#3182F7]" : "text-white"}`}
                            onClick={() => {
                                setDeviceData(deviceData.map(item =>
                                    item.id === dropdownInfo.deviceId ? { ...item, bedNumber: bed } : item
                                ));
                                setDropdownInfo({ open: false, type: '', anchorRect: null });
                            }}
                        >
                            {bed}
                            {deviceData.find(d => d.id === dropdownInfo.deviceId)?.bedNumber === bed && (
                                <IconCheck className="w-4 h-4 ml-2" />
                            )}
                        </div>
                    ))}
                </div>
            )}

            <Paging currentPage={pagingInfo.currentPage} goToPage={goToPage} totalPages={pagingInfo.totalPages} visibleCount={10} />

            {
                isAlertOpen && (
                    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50">
                        <Modal 
                            type={2}
                            isOpen={isAlertOpen}
                            title="Alert"
                            message={t('admin.device.confirm.cannotDelete')}
                            confirmText="OK"
                            onConfirm={() => setIsAlertOpen(false)}
                            onCancel={() => setIsAlertOpen(false)}
                        />
                    </div>                    
                )
            }

            {
                isPrint && (
                    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50">
                        <BarcodePrint                             
                            selectedDevices={deviceData.filter(device => device.isCheck)}
                            onClose={() => setIsPrint(false)}
                        />
                    </div>  
                )
            }


        </div>
    )
};


export default PmdMngt
